
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartInfo as ObiChartInfoElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-info.js';
 
 
 

 
 export const ObiChartInfo = createComponent({
   react: React,
   tagName: 'obi-chart-info',
   elementClass: ObiChartInfoElement,
   events: {
     
   }
  });
 
 